<template>
    <div>
        <div ref="modalRoot" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
            <div class="modal-dialog modal-l" role="document">
                <div class="modal-content sub-modal-content">
                    <div class="modal-header">
                        <h4>ระบุรายการอะไหล่ซัพพลายเออร์</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="kt-portlet__body">
                            <div class="kt-section kt-section--first">
                                <div class="row">
                                    <div class="col-xl-12">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th style="width:50px !important; text-align:center;">ลำดับ</th>
                                                    <th style="width:300px !important; text-align:center;">ชื่ออะไหล่</th>
                                                    <th style="width:80px !important; text-align:center;">จำนวน</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                <tr v-for="(part, index) in masterProductSpareList" :key="part.id">
                                                    <td style="text-align:center;">{{ index + 1 }}</td>
                                                    <td style="text-align:center;">{{ part.materialDesc_th }} [{{part.materialCode}}]</td>
                                                    <td style="text-align:center;">
                                                        <input type="number"
                                                               v-model.number="part.qty"
                                                               :min="0"
                                                               step="1"
                                                                @input="validateUInt(part)"
                                                               placeholder="0" 
                                                               style="width:80px;text-align:center;"
                                                               />
                                                    </td>
                                                </tr> 
                                            </tbody>
                                        </table>
                                    </div>
                                </div> <!-- end row -->

                            </div>
                        </div>
                        <div class="kt-portlet__foot">
                            <button type="button" data-dismiss="modal" class="btn btn-secondary"><i class="la la-close"></i> ย้อนกลับ</button>
                            <button type="button" data-dismiss="modal" class="btn btn-primary" @click.prevent="save()"><i class="la la-save"></i> บันทึกข้อมูล</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
        //barcode: Object,
        //spareParts: Array,
        //selectedBarcode:null
  }   , 
  data: function() {
    return {
        masterProductSpareList: [], // loaded from API
        selectedBarcode:null
    };
  },
methods: {
    validateUInt(part) {
        // ถ้าเป็น NaN หรือ < 0 ให้กลับไปเป็น 0
        if (part.qty === '' || part.qty === null || isNaN(part.qty) || part.qty < 0) {
            part.qty = 0;
        }
        // ตัดทศนิยมออก (force uint)
        part.qty = Math.floor(part.qty);
    },
     open(barcode) {
        this.selectedBarcode = barcode;
        this.fetchMasterProductSpareList(); // โหลด list ทุกครั้งที่เปิด

          //this.updateMasterQtyFromSelectedBarcode(); // sync qty จาก used items

        this.$nextTick(() => {
            //$(this.$refs.modalRoot).modal('show');
            $(this.$refs.modalRoot).modal({
                backdrop: 'static',
                keyboard: false
            });
        });
     },
     async fetchMasterProductSpareList() {
        try {
            
            var url = "/Api/Jobs/GetSupplierSpare";
            axios
                .get(url).then((response) => {
                    if (response.status == 200) {
                        this.masterProductSpareList = response.data;

                        // Update Qty from spareUsed
                        this.updateMasterQtyFromSelectedBarcode();

                        //console.log("supplier spare data : "+response.data.length);
                    } else {
                        Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลอะไหล่ซัพพลายเออร์", "warning");
                        KTApp.unblockPage();
                    }
                })
                .catch(function (error) {
                    Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลได้ในขณะนี้", "error");
                    KTApp.unblockPage();
                })
                .then(function () {
                    // always executed
                    KTApp.unblockPage();
                });

        } catch (error) {
            console.error('โหลดข้อมูล master ล้มเหลว:', error);
        }
      },
     updateMasterQtyFromSelectedBarcode() {
         const usedItems = (this.selectedBarcode && this.selectedBarcode.sparePartUsedItems) || [];

         //console.log("UsedItems : " + usedItems.length);
         //usedItems.forEach(used => {
         //    console.log(" Used:" + used.spareMaterialCode + ", qty " + used.spareUsedQty);
         //});

         //this.masterProductSpareList.forEach(master => {
         //     //const matched = usedItems.find(item => item.spareMaterialCode === master.materialCode);
         //     //usedItems.forEach(used => {
         //         console.log("master:" + master.materialCode);
         //     //});
         //     //master.qty = matched ? matched.spareUsedQty : 0;
         //});

         //=== start set qty ===
         this.masterProductSpareList.forEach(master => {
             //console.log("master:", master.materialCode);
             const matched = usedItems.find(item =>
                 String(item.spareMaterialCode).trim() === String(master.materialCode).trim()
             );

             master.qty = matched ? matched.spareUsedQty : 0;
         });

      },
        
      save() {
          this.$emit('save', this.masterProductSpareList); // ส่งค่ากลับให้ parent
          $(this.$refs.modalRoot).modal('hide');

          
    },
    close() {
        this.$emit('close');
        $(this.$refs.modalRoot).modal('hide');
    }
      
  },
  async mounted() {
      // เมื่อปิด Sub-Modal ให้คืน scroll ให้ Modal แม่
      $(this.$refs.modalRoot).on('hidden.bs.modal', () => {
          if ($('.modal.show').length > 0) {
              $('body').addClass('modal-open');
          }
      });
  }
};
</script>

<style lang="scss" scoped>
    .table td {
        padding: 0.1rem;
        vertical-align: middle;
    }
    .table th {
        padding: 0.5rem;
        vertical-align: middle;
    }
    .sub-modal-content {
        background-color: #f0f8ff; /* สีฟ้าอ่อน */
        border: 2px solid #007bff; /* ขอบสีฟ้า */
        box-shadow: 0 0 20px rgba(0, 123, 255, 0.4); /* แสงเงา */
        border-radius: 8px;
    }
</style>


// WEBPACK FOOTER //
// App/Components/Job/JobAddSpareUsedList.vue